import { AuditItemResponse, PermissionBit } from "../../../api";
import { DataModel } from "../../../models/data-model";

export class Logs extends DataModel<AuditItemResponse> {
  constructor(
    data: AuditItemResponse[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);
  }
}
